"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.distanceToSpline = distanceToSpline;
var _getPointTangent = require("./getPointTangent");
var _brentsmethod = require("./brentsmethod");
var _vector = require("./vector");
/**
 * Given a spline and a point P, find a point Q on the spline whose distance to P is a locally minimized. The algorithm
 * works by finding a point on the spline Q such that the dot product of PQ and the tangent at Q is zero. 
 * @param {Vector} P The point
 * @param {Spline} spline The spline
 * @param {boolean} includeEndPoints Also tests the endpoints of the spline.
 * @param {number} initialSubdivisions Number of initial subdivisions to make. Larger number increases the chance of bracketing the global minimum.
 * @returns {{ distance: number, closestPoint: Vector, t: number}} The perpendicular distance to the spline, or null if
 * a local minimum could not be bracketed and includeEndPoints is false.
 */
function distanceToSpline(P, spline, includeEndPoints = false, initialSubdivisions = 8) {
  const objFunc = t => {
    const [pt, tan] = (0, _getPointTangent.getPointTangentOfEntity)(spline, t);
    return (0, _vector.dot)((0, _vector.sub)(P, pt), tan);
  };
  let localMinima = includeEndPoints ? [0, 1] : [];
  for (let i = 0; i < initialSubdivisions; i++) {
    let t1 = i / initialSubdivisions;
    let t2 = (i + 1) / initialSubdivisions;
    let f1 = objFunc(t1);
    let f2 = objFunc(t2);
    if (f1 === 0) {
      localMinima.push(t1);
    } else if (f1 > 0 && f2 < 0) {
      // Local minimum in this region
      let result = (0, _brentsmethod.brent)(objFunc, t1, t2, {
        errorTolerance: 1e-7,
        maxIterations: 50
      });
      if (result !== false) {
        localMinima.push(result);
      }
    }
  }

  // Test each local minimum
  let bestDist = Infinity;
  let bestT = null;
  let bestPt = null;
  for (let t of localMinima) {
    let [pt] = (0, _getPointTangent.getPointTangentOfEntity)(spline, t);
    let dist = (0, _vector.norm)((0, _vector.sub)(P, pt));
    if (dist < bestDist) {
      bestDist = dist;
      bestT = t;
      bestPt = pt;
    }
  }
  if (bestT != null) {
    return {
      distance: bestDist,
      closestPoint: bestPt,
      t: bestT
    };
  } else {
    return null;
  }
}